import { render, staticRenderFns } from "./policy-tab.vue?vue&type=template&id=71d8ce45&scoped=true&"
import script from "./policy-tab.vue?vue&type=script&lang=js&"
export * from "./policy-tab.vue?vue&type=script&lang=js&"
import style0 from "./policy-tab.vue?vue&type=style&index=0&id=71d8ce45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d8ce45",
  null
  
)

export default component.exports